export const NO_ASSIGNED_TOPIC = 'No assigned topic'
export const NO_ASSIGNED_TITLE = 'No assigned title'
export const DFM_APPROVAL_REQUIRED = 'approval-required'
export const DFM_APPROVED = 'approved'
export const DFM_NEEDS_FICTIV_REVIEW = 'needs-fictiv-review'
export const DFM_NO_ACTION_REQUIRED = 'no-action-required'
export const DFM_PENDING_REVISION = 'pending-revision'
export const DFM_REVISION_REQUIRED = 'revision-required'
export const DFM_WARNING = 'warning'
export const DFM_WARNING_ACCEPTED = 'warning-accepted'
export const DFM_FICTIV_REVIEW_REQUESTED = 'fictiv-review-requested'

export const UPDATE_TOPIC_ERROR_MSG =
    'Failed to update topic, please try again.'
export const UPDATE_TITLE_ERROR_MSG =
    'Failed to update title, please try again.'
export const UPDATE_STATUS_ERROR_MSG =
    'Failed to update status, please try again.'

export type ImDfmStateType =
    | typeof DFM_APPROVAL_REQUIRED
    | typeof DFM_APPROVED
    | typeof DFM_NEEDS_FICTIV_REVIEW
    | typeof DFM_NO_ACTION_REQUIRED
    | typeof DFM_PENDING_REVISION
    | typeof DFM_REVISION_REQUIRED
    | typeof DFM_WARNING
    | typeof DFM_WARNING_ACCEPTED
    | typeof DFM_FICTIV_REVIEW_REQUESTED

export const DFM_STATES: { [key in ImDfmStateType | string]: string } = {
    [DFM_APPROVAL_REQUIRED]: 'Approval required',
    [DFM_APPROVED]: 'Approved',
    [DFM_NEEDS_FICTIV_REVIEW]: 'Pending Fictiv review',
    [DFM_NO_ACTION_REQUIRED]: 'No action required',
    [DFM_PENDING_REVISION]: 'Pending new revision',
    [DFM_REVISION_REQUIRED]: 'Revision required',
    [DFM_WARNING_ACCEPTED]: 'Warning accepted',
    [DFM_WARNING]: 'Warning',
    [DFM_FICTIV_REVIEW_REQUESTED]: 'Fictiv Review Requested',
}

export const DFM_STATE_COLORS: { [key in ImDfmStateType | string]: string } = {
    [DFM_APPROVAL_REQUIRED]: 'warning6',
    [DFM_APPROVED]: 'primary6',
    [DFM_NEEDS_FICTIV_REVIEW]: 'info6',
    [DFM_NO_ACTION_REQUIRED]: 'grey7',
    [DFM_PENDING_REVISION]: 'error6',
    [DFM_REVISION_REQUIRED]: 'error6',
    [DFM_WARNING_ACCEPTED]: 'primary6',
    [DFM_WARNING]: 'warning6',
    [DFM_FICTIV_REVIEW_REQUESTED]: 'info6',
}
